import React, { createContext, useReducer } from "react";
import Reducer from "./reducer";

const initialState = {
  user_data: {
    isLogin: false,
    isModal: true,
    whatsapp_modal: false,
    refresh_token: "",
    access_token: "",
    student_id: "",
    first_watch: "",
  },
};
const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);

export default Store;
